/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import { SearchInputComponent } from "../../../../common/components";
import { UserManagementListFilterProps } from "./user-management-list-filter.props";
import FilterIcon from "../../../../assets/icons/filter-icon.svg";
import "./user-management-list-filter.scss";
import { useResourcePermissions } from "../../../../common/hooks/resource-permissions";
import MODULES from "../../../../constants/modules";
import CompanyFilter from "../components/company-filter/company-filter";
import { useLogin } from "../../../../common/hooks/useUser";
import { useMediaQuery } from "@mui/material";

const UserManagementListFilter: React.FC<UserManagementListFilterProps> = (
  props: any
) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    onSearch,
    selectedUserManagementListFilter,
    handleAddClick,
    companyNames,
    onApplyFilter,
    filters,
  } = props;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { canWrite } = useResourcePermissions(MODULES.USER_LISTS);
  const tenantDetails = useLogin();
  const isSuperParter = useMemo(() => {
    return tenantDetails?.tenantDetails?.tenantType === "SuperTenant";
  }, [tenantDetails?.tenantDetails?.tenantType]);

  return (
    <div className="user-management-list-search-filter-wrapper">
      <div className="user-management-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by first name, last name, email etc.,"
          onSearch={onSearch}
        />
        {isMobile && (
          <div
            className={`user-management-list-icon-filter ${isOpenFilter ? "active-filter" : ""}`}
            onClick={() => setIsOpenFilter(!isOpenFilter)}
            tabIndex={0}
          >
            <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
              <Badge
                color="secondary"
                badgeContent={selectedUserManagementListFilter}
              >
                <img src={FilterIcon} alt="Filter Icon" />
              </Badge>
            </Stack>
          </div>
        )}
      </div>
      <div className="user-management-list-filter-wrapper">
        <div>
          {isSuperParter && (
            <CompanyFilter
              options={companyNames}
              filters={filters}
              onApplyFilter={onApplyFilter}
            />
          )}
        </div>
        {!isMobile && (
          <div
            className={`user-management-list-icon-filter ${isOpenFilter ? "active-filter" : ""}`}
            onClick={() => setIsOpenFilter(!isOpenFilter)}
            tabIndex={0}
          >
            <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
              <Badge
                color="secondary"
                badgeContent={selectedUserManagementListFilter}
              >
                <img src={FilterIcon} alt="Filter Icon" />
              </Badge>
            </Stack>
          </div>
        )}
        <div className="user-management-list-create-filter">
          {canWrite && (
            <button
              className="user-management-list-create-filter-button"
              onClick={handleAddClick}
              disabled={false}
            >
              Add User
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserManagementListFilter;
